// components/Products/DeleteProductModal.js
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";

const DeleteProductModal = ({ isOpen, toggle, product, onDelete }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await onDelete();
    } catch (error) {
      console.error("Failed to delete product:", error);
    } finally {
      setDeleting(false);
    }
  };

  if (!product) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Delete Product</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <i className="fas fa-exclamation-triangle fa-3x text-danger mb-3"></i>
          <h5>Are you sure you want to delete this product?</h5>

          <div className="mt-3 p-3 border rounded bg-light">
            <div className="d-flex align-items-center">
              {product.imagelink && (
                <img
                  src={product.imagelink}
                  alt={product.productname}
                  className="rounded me-3"
                  style={{ width: "50px", height: "50px", objectFit: "cover" }}
                />
              )}
              <div>
                <div className="fw-semibold">{product.productname}</div>
                <small className="text-muted">
                  {product.productbrand} • ID: #{product.id}
                </small>
              </div>
            </div>

            <div className="mt-3 row text-start">
              <div className="col-md-6">
                <small className="text-muted d-block">Category</small>
                <div>{product.category} / {product.subcategory}</div>
              </div>
              <div className="col-md-6">
                <small className="text-muted d-block">MRP</small>
                <div className="fw-semibold">৳{product.mrp}</div>
              </div>
            </div>
          </div>

          {/* <div className="alert alert-danger mt-3">
            <i className="fas fa-exclamation-circle me-2"></i>
            <strong>Warning:</strong> This action cannot be undone. The product will be permanently removed from the system.
          </div> */}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={deleting}>
          Cancel
        </Button>
        <Button
          color="danger"
          onClick={handleDelete}
          disabled={deleting}
        >
          {deleting ? (
            <>
              <Spinner size="sm" className="me-2" />
              Deleting...
            </>
          ) : (
            <>
              <i className="fas fa-trash me-2"></i>
              Delete Product
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteProductModal;